import React from 'react';

export const useOnClickOutside = (cb: any) => {
  const ref = React.useRef<HTMLInputElement>(null);
  React.useEffect(() => {
    function onClick(e: any): any {
      if (ref && ref.current && !ref.current.contains(e.target)) {
        cb(e);
      }
    }
    document.addEventListener('mousedown', onClick);
    document.addEventListener('touchstart', onClick);
    return (): void => {
      document.removeEventListener('mousedown', onClick);
      document.removeEventListener('touchstart', onClick);
    };
  }, [cb]);

  return ref;
};
